<template>
  <!-- <div class="text-center"> -->
  <!-- <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on }">
        <v-btn color="info" fab small v-on="on">
          <v-icon>filter</v-icon>
        </v-btn>
      </template>

      <v-card class="pa-3">
        <v-flex style="display: flex; justify-content: flex-end">
          <v-btn icon @click="menu = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>

        <v-divider></v-divider>

        <v-card-text class="grey--text subtitle-1 mb-0 pb-0">
          <div>Sign Mode</div>
          <div style="display: flex; justify-content: space-between;">
            <v-checkbox
              v-model="options.sign_mode"
              label="Sign In"
              color="secondary"
              value="in"
            ></v-checkbox>
            <v-checkbox
              v-model="options.sign_mode"
              label="Sign Out"
              color="secondary"
              value="out"
            ></v-checkbox>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="grey--text subtitle-1">
          <div>Type exact first name or last name</div>
          <div class="d-flex justify-space-between">
            <v-text-field
              v-model="options.first_name"
              label="First Name"
              required
              @input="changeFirstName"
            ></v-text-field>
            <div class="pa-2"></div>
            <v-text-field
              v-model="options.last_name"
              label="Last Name"
              required
              @input="changeLastName"
            ></v-text-field>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="grey--text subtitle-1">
          <div>Select data range from calendar</div>
          <div class="d-flex justify-space-between">
            <calendar v-model="options.from_date" placeholder="From Date" />
            <div class="pa-2"></div>
            <calendar v-model="options.to_date" placeholder="To Date" />
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions style="display: flex; justify-content: flex-end">
          <div class="text-xs-right">
            <v-btn color="info" text @click="applyOptions">Apply</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-menu> -->
  <v-container class="pa-1 mb-3 elevation-2 white" fluid>
    <v-layout row class="pl-3 pr-3 d-flex" wrap>
      <v-layout column wrap class="pa-3 mt-1 ml-1">
        <v-checkbox
          v-model="options.sign_mode"
          label="Sign In"
          color="secondary"
          value="in"
        ></v-checkbox>
        <v-checkbox
          v-model="options.sign_mode"
          label="Sign Out"
          color="secondary"
          value="out"
        ></v-checkbox>
      </v-layout>

      <v-layout column class="pa-3">
        <v-text-field
          v-model="options.first_name"
          label="First Name"
          required
          @input="changeFirstName"
        ></v-text-field>
        <v-text-field
          v-model="options.last_name"
          label="Last Name"
          required
          @input="changeLastName"
        ></v-text-field>
      </v-layout>

      <v-layout column class="pa-3">
        <calendar v-model="options.from_date" placeholder="From Date" />
        <calendar v-model="options.to_date" placeholder="To Date" />
      </v-layout>

      <v-layout column align-end class="pb-4 pr-2" style="width: 50px;">
        <v-btn color="primary" style="width: 100px;" @click="printList">
          Print
        </v-btn>
        <v-btn
          class="mb-3"
          style="width: 100px;"
          color="info"
          text
          @click="applyOptions"
          >Apply</v-btn
        >
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */ 
import Calendar from "./FilterCalendar";
export default {
  components: {
    Calendar,
  },
  data() {
    return {
      fav: true,
      menu: false,
      message: false,
      hints: true,
      options: this.$store.state.filterOptions,
    };
  },
  watch: {
    options: {
      handler: function () {
        this.$store.commit("applyFilters", this.options);
      },
      deep: true,
    },
  },
  beforeCreate() {
    this.$store.commit("resetFilters");
  },
  created() {
    this.options = this.$store.state.filterOptions;
  },
  methods: {
    printList: function () {
      this.$emit("printReport", this.options);
    },
    applyDateRange: function (start, end) {
      this.options.from_date = start;
      this.options.to_date = end;
    },
    changeFirstName: function () {
      this.options.last_name = "";
    },
    changeLastName: function () {
      this.options.first_name = "";
    },
    applyOptions: function () {
      this.$emit("apply");
      this.menu = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
.v-input__slot {
  display: flex;
  align-items: baseline;
}
</style>
